import { Component, Input, OnChanges, SimpleChanges, OnInit } from '@angular/core';

import { IDashBoardAdminChartDetailsWithProvider } from '../dasboard-admin-chart-details.model';
import { ChartValue } from '../chart/chart-value.model';
import { DateHelperService } from '../../core/services';
import { BarChartOptions } from "../chart/bar-chart-options.model";
import { IPublisher } from "../../shared/publisher.model";
import { WebWorkerService } from "angular2-web-worker/web-worker.service";

@Component({
    moduleId: module.id,
    selector: 'revenue-by-source',
    templateUrl: 'revenue-by-source.component.html'
})
export class RevenueBySourceComponent implements OnInit, OnChanges {
    @Input() data: IDashBoardAdminChartDetailsWithProvider;
    @Input() dataForToday: IDashBoardAdminChartDetailsWithProvider;
    @Input() period: string;
    @Input() showTopSectionOverlay: boolean;
    toolTipText: string = "{2} {0} {1} ";
    chartValues: ChartValue[];
    triggerChange: Date;
    chartOptions: BarChartOptions;

    constructor(
        private dateHelper: DateHelperService,
        private webWorkerService: WebWorkerService) {
    }

    ngOnInit(){
        this.chartOptions = new BarChartOptions();
        this.chartOptions.yaxis = { tickFormatter: this.format };
        this.chartOptions.roundTooltip = true;
        this.chartOptions.tooltipCurrency = '$ ';
    }

    private format(val, axis): string {
        return "$" + Math.round(val.toFixed(2));
    }
    private mapAllData(): void {
        this.chartValues = new Array<ChartValue>();
        let publishers: IPublisher[] = new Array<IPublisher>();
        for (let item of this.data.revenuesBySource) {
            if (publishers.findIndex(s => s.id == item.publisher.id) === -1)
                publishers.push(item.publisher);
        }

        if (publishers.length > 0) {
            for (let publisher of publishers) {
                let chartValue = new ChartValue(publisher.name);
                chartValue.identifier = publisher.id;
                let revenues = this.data.revenuesBySource.filter(x => x.publisher.id == publisher.id);
                for (let item of revenues) {
                    chartValue.data.push([this.dateHelper.getTicks(item.revenues.dateUtc), item.revenues.earning]);
                    chartValue.lastItemIdentifier = item.revenues.dateUtc;
                }
                this.chartValues.push(chartValue);
            }
        }
        for (let chart of this.chartValues) {
            chart.data = chart.data.sort((a: number, b: number) => {
                return a[0] - b[0];
            })
        }
    }

    private mapTodayData(params: any): void {
        Array.prototype.findIndex||Object.defineProperty(Array.prototype,"findIndex",{value:function(r){if(null==this)throw new TypeError('"this" is null or not defined');var e=Object(this),t=e.length>>>0;if("function"!=typeof r)throw new TypeError("predicate must be a function");for(var n=arguments[1],o=0;o<t;){var i=e[o];if(r.call(n,i,o,e))return o;o++}return-1}}),Array.prototype.find||Object.defineProperty(Array.prototype,"find",{value:function(r){if(null==this)throw new TypeError('"this" is null or not defined');var e=Object(this),t=e.length>>>0;if("function"!=typeof r)throw new TypeError("predicate must be a function");for(var n=arguments[1],o=0;o<t;){var i=e[o];if(r.call(n,i,o,e))return i;o++}}});
        let publishers = new Array();
        for (let item of params.dataForToday.revenuesBySource) {
            if (publishers.findIndex(s => s.id == item.publisher.id) === -1)
                publishers.push(item.publisher);
        }

        if (publishers.length > 0) {
            for (let publisher of publishers) {
                let chartValue = params.chartValues.find(x => x.identifier == publisher.id);
                if (chartValue) {
                    let lastValue = chartValue.data[chartValue.data.length - 1];
                    let revenues = params.dataForToday.revenuesBySource.filter(x => x.publisher.id == publisher.id);
                    for (let item of revenues) {
                        if (formatDate(item.revenues.dateUtc) == formatDate(chartValue.lastItemIdentifier)) {
                            lastValue[1] = item.revenues.earning;
                        }
                    }
                }
            }
        }
        function formatDate(date: Date) {
            let _date = new Date(date);
            let day = _date.getDate();
            let monthIndex = _date.getMonth();
            let year = _date.getFullYear();
            return year + '-' + monthIndex + '-' + day;
        }
        return params;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.data && changes["data"] && changes["data"].previousValue != changes["data"].currentValue)
            this.mapAllData();
        if (this.dataForToday) {
            let params = {
                dataForToday: this.dataForToday,
                chartValues: this.chartValues,
            }
            if (typeof (Worker) !== "undefined") {
                this.webWorkerService.run(this.mapTodayData, params).then((res) => {
                    this.onMapTodayData(res);
                }).catch((r) => { console.log(r) });
            } else {
                let res = this.mapTodayData(params);
                this.onMapTodayData(res);
            }
        }
    }

    private onMapTodayData(res: any) {
        this.dataForToday = res.dataForToday;
        this.chartValues = res.chartValues;
        this.triggerChange = new Date();
    }
}


// WEBPACK FOOTER //
// ./src/app/dashboard/revenuebysource/revenue-by-source.component.ts